import React from "react";
import Updates from "./Updates.js";

const Welcome = props => {
  return (
    <div>
      <p className="step-p">
        A blockchain is a distributed database secured by cryptography. It is
        the technology behind Bitcoin.
      </p>
      <p className="step-p">
        This demo will guide you through the blockchain step-by-step. This demo
        is also covered in this{" "}
        <a
          href="https://medium.freecodecamp.org/how-does-blockchain-really-work-i-built-an-app-to-show-you-6b70cd4caf7d"
          rel="noopener noreferrer"
          target="_blank"
        >
          Medium article with freeCodeCamp
        </a>. For an understanding of cryptocurrency transactions, checkout{" "}
        <a
          href="https://coindemo.io"
          rel="noopener noreferrer"
          target="_blank"
        >
          Coin Demo
        </a>.
      </p>
      <p className="step-p">
        To{" "}
        <b>
          <b>jump between steps</b>
        </b>, hover on the title of this dialog and select a step.
      </p>{" "}
      <Updates />
    </div>
  );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/steps/welcome/welcome-step.js